module.exports = __webpack_public_path__ + "img/shuicao1.4fc2e345.gif";